import { useSyncExternalStore } from "react";

/**
 * Tiny global store for the single authoritative "Customize Navigation"
 * interface. Any entry point (hamburger long-press, "Customize nav" button,
 * bottom-nav edit mode) opens the same surface.
 */

let open = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((l) => l());
}

export function openNavCustomizer() {
  if (open) return;
  open = true;
  emit();
}

export function closeNavCustomizer() {
  if (!open) return;
  open = false;
  emit();
}

export function setNavCustomizerOpen(next: boolean) {
  if (next === open) return;
  open = next;
  emit();
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function useNavCustomizerOpen(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => open,
    () => false,
  );
}
